<div class="d-flex flex-column align-items-center vh-100 justify-content-center">
  <h1>You are now signed out!</h1>
  <button mat-icon-button
    routerLink="/sign-in">
    <mat-icon>login</mat-icon>
  </button>
</div>